import { ScheduleByDepartmentModel } from '@/models/schedule'
import { api } from '@/services/api'

type FetchScheduleParams = {
  departmentId: string
  companyId: string
}

export type FetchScheduleResponse = {
  schedule: ScheduleByDepartmentModel
}

export async function fetchSchedule(params: FetchScheduleParams) {
  const queryParams = `?departmentId=${params.departmentId}&companyId=${params.companyId}`

  const response = await api.get<FetchScheduleResponse>(`/schedules/by-department${queryParams}`)
  return response.data
}
